import { EventEmitter, Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { AppService, AppStorageKeys } from '@app/services/app.service';

// TODO: Alguma hora dessas, colocar essa ModalService em @app/services, já que ela está usando a AppService de lá

@Injectable({ providedIn: 'root' })
export class ModalService {
  activeInstances: EventEmitter<NgbModalRef[]>;

  constructor(
    private ngbModal: NgbModal,
    private appService: AppService
  ) {
    this.activeInstances = this.ngbModal.activeInstances;
  }

  open<T>(component: any, properties?: { [k: string]: any }, options?: NgbModalOptions, throwErrorOnDismiss?: boolean) {
    return new Observable<T>(subscriber => {
      const newOptions = { ...options };
      const windowClasses: string[] = [];

      // Add darkmode class if enabled
      if (this.appService.isDarkmode) {
        windowClasses.push(AppStorageKeys.Darkmode);
      }

      // Add existing classes from options
      if (options?.windowClass) {
        windowClasses.push(options.windowClass);
      }

      newOptions.windowClass = windowClasses.join(' ');

      this.blurActiveElement();

      const modal = this.ngbModal.open(component, newOptions);
      Object.keys(properties || {}).forEach(key => (modal.componentInstance[key] = properties[key]));

      modal.result
        .then(data => subscriber.next(data))
        .catch(data => (throwErrorOnDismiss ? subscriber.error(data) : null))
        .finally(() => subscriber.complete());
    });
  }

  dismissAll(): void {
    this.ngbModal.dismissAll();
  }

  hasOpenModals() {
    return this.ngbModal.hasOpenModals();
  }

  private blurActiveElement() {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
}
